import { render, staticRenderFns } from "./config-detailed-report-table.vue?vue&type=template&id=21d6c6f8"
import script from "./config-detailed-report-table.vue?vue&type=script&lang=js"
export * from "./config-detailed-report-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports